import { RestaurantTagCreate } from "../../Component/RestaurantTag/RestaurantTagCreate";
import { constants } from "../../Constants/constants";

import "../../styles/map.css";

export const RestaurantKeywordCreate = () => {
  return (
    <RestaurantTagCreate resource={constants.PATH.RESTAURANT_TAG.RESTAURANT_KEYWORD} resourceName="restaurant_keyword" />
  );
};
